module.exports = __webpack_public_path__ + "static/media/mailing.21fc3ff0.svg";